module.exports = __webpack_public_path__ + "static/media/icon_run_blue.8064dc90.svg";